import { render } from "./GivingForm.vue?vue&type=template&id=c92d97ec&scoped=true"
import script from "./GivingForm.vue?vue&type=script&lang=js"
export * from "./GivingForm.vue?vue&type=script&lang=js"

import "./GivingForm.vue?vue&type=style&index=0&id=c92d97ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92d97ec"]])

export default __exports__